import styled from 'styled-components';

// TODO: refactor
const ModalContainerStyled = styled.div`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: 0.5;
  }

  .modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
  }

  .modal-header {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 25px;
    top: 20px;
  }

  .modal-close-button {
    font-size: 1.48rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    background: white;
    cursor: pointer;
    border: none;
  }

  button {
    font-size: 0.9rem;
    font-weight: 700;
    border: none;
    border-radius: 3px;
    padding: 0.1rem 1rem;
    margin-left: 0.5rem;
    &:focus {
      outline: none;
    }
  }
  iframe {
    width: 100%;
    height: 100%;
    max-height: auto;
    @media (max-width: 820px) {
      height: 500px;
    }
  }
  .hide {
    display: none;
  }
`;

const ModalStyled = styled.div`
  z-index: 100;
  background: #fff;
  position: relative;
  margin: 1rem auto;
  border-radius: 3px;
  max-width: 500px;
  height: 95%;
  @media (max-width: 820px) {
    max-width: 98%;
    max-height: 500px;
  }
`;

export { ModalContainerStyled, ModalStyled };
